import { FlaskConical } from 'lucide-react';
import { usePreliminarStore } from '@/shared/stores/preliminarStore';
import { Switch } from '@/shared/ui/switch/Switch';
import { cn } from '@/shared/lib/utils';

interface PreliminarToggleProps {
  className?: string;
}

/**
 * Opt-in global para incluir periodos ABIERTO (preliminares) en los módulos EF.
 * Las páginas lo envuelven en el contenedor de su propia barra de filtros.
 */
export function PreliminarToggle({ className }: PreliminarToggleProps) {
  const incluirAbierto = usePreliminarStore(state => state.incluirAbierto);
  const setIncluirAbierto = usePreliminarStore(state => state.setIncluirAbierto);

  return (
    <label className={cn('flex cursor-pointer items-center gap-2', className)}>
      <FlaskConical className="h-4 w-4 text-secondary" />
      <span className="text-sm font-semibold whitespace-nowrap">Periodo abierto</span>
      <Switch
        checked={incluirAbierto}
        onCheckedChange={setIncluirAbierto}
        aria-label="Incluir periodo abierto"
      />
    </label>
  );
}
